import CurriculumContentStrategy from '@core/domain/course/strategy/CurriculumContentStrategy';

import { COURSE_ITEMS_CONTENT_TYPE } from '@helpers/constants';
import { CourseCurriculumArticleContentEntity } from '@redux/course/type/courseDetailType';

class CurriculumArticleContentStrategy extends CurriculumContentStrategy {
  protected readonly type: COURSE_ITEMS_CONTENT_TYPE.ARTICLE;

  protected readonly icon: string;

  constructor(content: CourseCurriculumArticleContentEntity) {
    super(content);

    this.type = COURSE_ITEMS_CONTENT_TYPE.ARTICLE;
    this.icon = 'fa-light fa-file-lines';
  }

  getType() {
    return this.type;
  }

  getIcon() {
    return this.icon;
  }
}

export default CurriculumArticleContentStrategy;
